/**
 * zhihao-ui-react 的多选 Select 默认只展示一个标签；旧版 Vue Select 会把所有已选项换行展示。
 * 传入足够大的数量即可保留所有标签，再由全局样式负责换行和自适应高度。
 */
export const SHOW_ALL_SELECT_TAGS = Number.MAX_SAFE_INTEGER;
